import styled from 'styled-components';

export const Toggle = styled.div`
  height: 25px;
  width: 60px;
  border-radius: 50px;
  background-color: ${(props) => (!props.dark ? '#c3e4f7' : '#344658')};
  position: relative;
  z-index: 1;
  cursor: pointer;
`;

export const Notch = styled.div`
  position: absolute;
  height: 15px;
  width: 15px;
  border-radius: 50%;
  background: ${(props) => (!props.dark ? '#3B96ED' : 'whitesmoke')};
  transform: ${(props) =>
    !props.dark ? 'translate(0,0)' : 'translate(35px,0)'};
  top: 5px;
  left: 5px;
  transition: all 0.4s ease;
`;
